<template>

  <div class="col-12 table-responsive">

    <table class="table table-bordered">

      <tr>
        
        <th 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key"
          v-show="!tableParameterItem.hide" >
          {{ tableParameterItem.text || tableParameterItem.key }}
        </th>

      </tr>

      <tr 
        v-for="(leaseDataItem, leaseDataIndex) in leaseData"
        v-show="leaseDataItem.leaseSelected"
        v-bind:key="leaseDataItem.id" >

        <td 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key"
          v-show="!tableParameterItem.hide" >

          <span v-if="tableParameterItem.key === 'index'">{{ leaseDataIndex + 1 }}</span>

          <input
            v-else-if="tableParameterItem.key === 'leaseSelected'"
            v-model="leaseDataItem['leaseSelected']"
            type="checkbox"
            v-bind="leaseEnableEdit ? {} : {'disabled':0}" />

          <div 
            v-else-if="tableParameterItem.key === 'leasePasscard'"
            v-html="leaseDataItem['_lostDamageFaultyPasscardSku'] || leaseDataItem['_returnPasscardSku'] || leaseDataItem[tableParameterItem.key] " />

          <div 
            v-else-if="tableParameterItem.key === 'leasePasscardStatus'">
            <div v-if="leaseDataItem[tableParameterItem.key] === 'Passcard Returned'">
              <a target="_blank" v-bind:href="'/passcardTerminationForm?carparkID=' + leaseDataItem['carparkID'] + '&applicationID=' + leaseDataItem['_returnFormId']">{{ leaseDataItem[tableParameterItem.key] }}</a>
            </div>
            <div v-else-if="leaseDataItem[tableParameterItem.key] === 'Lost Passcard' || leaseDataItem[tableParameterItem.key] === 'Damaged Passcard'">
              <a target="_blank" v-bind:href="'/passcardLostDamageFaultyForm?carparkID=' + leaseDataItem['carparkID'] + '&applicationID=' + leaseDataItem['_lostDamageFaultyFormId']">{{ leaseDataItem[tableParameterItem.key] }}</a>
            </div>
            <div v-else>
              {{ leaseDataItem[tableParameterItem.key] }}
            </div>
          </div>

          <div 
            v-else-if="tableParameterItem.key === 'leaseSubscriptionStatus'"
            v-html="leaseDataItem['stopBillDate'] ? 'Stop Bill' : leaseDataItem[tableParameterItem.key]" />
          
          <div 
            v-else-if="tableParameterItem.key === 'leaseProductName'"
            v-html="leaseDataItem[tableParameterItem.key] + leaseDataItem['termination']" />

          <div 
            v-else
            v-html="leaseDataItem[tableParameterItem.key]" />
          
        </td>

      </tr>

      <tr>
        <td 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key"
          v-show="!tableParameterItem.hide" >
          {{ leaseTotal[tableParameterItem.key] }}
        </td>

      </tr>
        
    </table>

    *Refundable Fees are parking fees payment previously made which refundable, excluding Deposit.

    <button 
      v-show="leaseEnableAddDelete"
      class="btn btn-rounded btn-primary"
      v-on:click.prevent="onLeaseAddClick">
      Add Product Subscription
    </button>

    <TemplateFeedback ref="leaseFeedback" class="mt-1"/>

  </div>

</template>

<script>
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import helper from "@/components/Utility/Helper"

const PARAM = [
  {
    key: 'index',
    text: '#',
  },
  // {
  //   key: 'leaseSelected',
  //   text: ' '
  // },
  {
    key: 'leaseZone',
    text: 'Zone'
  },
  {
    key: 'leaseProductName',
    text: 'Product Name'
  },
  {
    key: 'leaseProductParkingFeePerMonth1Text',
    text: 'Parking Fee (RM)',
    hide: true,
  },
  {
    key: 'commencementDateText',
    text: 'Commencement Date',
  },
  {
    key: 'leaseParkerInformation',
    text: 'Parker Information',
  },
  {
    key: 'leaseSubscriptionStatus',
    text: 'Subscription Status',
    hide: true,
  },
  {
    key: 'leasePasscard',
    text: 'Passcard',
  },
  {
    key: 'leasePasscardStatus',
    text: 'Passcard Status',
  },
  {
    key: 'leaseProductDepositText',
    text: 'Deposit (RM)',
  },
  {
    key: 'leaseProductParkingFeePerMonthText',
    text: 'Parking Fee (RM)',
  },
  {
    key: 'leaseProRatedText',
    text: 'Pro-Rated (RM)',
  },
  {
    key: 'leaseCreditAmountText',
    text: 'Credit Amount (RM)',
  },
  {
    key: 'leaseRefundableFeesText',
    text: 'Refundable Fees (RM)',
  },
  {
    key: 'leaseNoticeText',
    text: 'Notice',
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePLTerminationFormLease",
  props: ['tableParameter'],
  components: {
    TemplateFeedback,
  },
  data () {
    return {
      PARAM,
      PARAM_MAP,

      tableSeason: null,
      tableParker: null,

      leaseData: [{}],
      leaseTotal: {},
      leaseEnableAddDelete: false,
      leaseEnableEdit: false,

      PRODUCT_PARAMS: ['leaseProductDeposit', 'leaseProductEstbFee', 'leaseProductInitialParkingFee', 'leaseProductInitialPayment', 'leaseProductParkingFee', 'leaseProRated', 'leaseCreditAmount', 'leaseRefundableFees', 'leaseProductParkingFeePerMonth', 'leaseProductParkingFeePerMonth1'],
      PARKER_PARAMS: ['leaseParkerName', 'leaseParkerMobile', 'leaseParkerPlate', 'leaseParkerEmail'],
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
  },
  methods: {
    setLeaseSubscriptionStatusVisible(visible) {
      if(visible) {
        this.PARAM_MAP['leaseProductParkingFeePerMonth1Text'].hide = false;
        this.PARAM_MAP['leaseSubscriptionStatus'].hide = false;
        
        this.PARAM_MAP['leaseProductDepositText'].hide = true;
        this.PARAM_MAP['leaseProductParkingFeePerMonthText'].hide = true;
        this.PARAM_MAP['leaseProRatedText'].hide = true;
        this.PARAM_MAP['leaseCreditAmountText'].hide = true;
        this.PARAM_MAP['leaseRefundableFeesText'].hide = true;
      } else {
        this.PARAM_MAP['leaseProductParkingFeePerMonth1Text'].hide = true;
        this.PARAM_MAP['leaseSubscriptionStatus'].hide = true;

        this.PARAM_MAP['leaseProductDepositText'].hide = false;
        this.PARAM_MAP['leaseProductParkingFeePerMonthText'].hide = false;
        this.PARAM_MAP['leaseProRatedText'].hide = false;
        this.PARAM_MAP['leaseCreditAmountText'].hide = false;
        this.PARAM_MAP['leaseRefundableFeesText'].hide = false;
      }
    },
    setLeaseData(leaseData, leaseEnableEdit) {
      this.leaseData = leaseData || [];
      this.leaseEnableEdit = leaseEnableEdit;
    },
    setLeaseTotal(leaseTotal) {
      leaseTotal = leaseTotal || {};
      this.PRODUCT_PARAMS.forEach(k => {
        leaseTotal[k + 'Text'] = leaseTotal[k + 'Text'] || helper.formatMoney(leaseTotal[k]);
      });
      this.leaseTotal = leaseTotal;
    },

    setLeaseDataSeason(data, season) {
      if(!season) {
        data['seasonID'] = null;
        this.removeLeaseDataSeasonField(data);
      }
    },
    setLeaseDataParker(data, parker) {
      if(!parker) {
        data['parkerID'] = null;
        this.removeLeaseDataParkerField(data);
      } else {
        data['leaseParkerInformation'] = helper.plFormParker(parker);
        this.$forceUpdate();
      }
    },
    
    removeLeaseDataSeasonField(data) {
      this.PRODUCT_PARAMS.forEach(k => {
        data[k] = null;
        data[k + 'Text'] = null;
      })
    },
    removeLeaseDataParkerField(data) {
      this.PARKER_PARAMS.forEach(k => {
        data[k] = null;
      })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLTerminationFormLease.vue